export enum EObstetricsAndGynecology {
  Obstetrics = 'san khoa',
  Gynecology = 'phu khoa'
}
